module.exports = __webpack_public_path__ + "img/ZA.9d0c21b1.svg";